class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)
    this.searchForm = document.getElementById('PredictiveSearchForm') ?? null

    this.debouncedOnSubmit = Shopycode.debounce((event) => {
      this.onSubmitHandler(event, null, this.searchForm?.dataset?.query ?? null)
    }, 500)

    const facetForm = this.querySelector('form')
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop')
    if (facetWrapper)
      facetWrapper.addEventListener('keyup', Shopycode.onKeyUpEscape)

      if (window.innerWidth >= 992) {
        document.getElementById('mobile-sort-by') && document.getElementById('mobile-sort-by').remove();
      }
  }

  static get observedAttributes() {
    return ['page-changed', 'query'] // List of attributes to observe
  }

  attributeChangedCallback(attributeName, oldValue, newValue) {
    if (attributeName === 'query' || attributeName === 'page-changed') {
      const page = this.getAttribute('page-changed');
      const query = this.getAttribute('query');
      this.onSubmitHandler(event, page, query);
    }
  }
  

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById('ProductCountDesktop')
    const countContainerDesktop = document.getElementById('ProductCountDesktop')
    document
      .getElementById('ProductGridContainer')
      .querySelector('.collection')
      .classList.add('loading')
    if (countContainer) {
      countContainer.classList.add('loading')
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading')
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url
      const overlay = document.querySelector('.js-collection-loading')
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)

      overlay ? overlay.classList.remove('loading') : ''
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.renderProductCount(html)
        window.isSearchPage && FacetFiltersForm.renderSearchForm(html)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    FacetFiltersForm.renderProductCount(html)
    window.isSearchPage && FacetFiltersForm.renderSearchForm(html)
  }

  static renderProductGridContainer(html) {
    let parser = new DOMParser().parseFromString(html, 'text/html'),
      currentProductGrid = document.getElementById('product-grid'),
      productCounter = currentProductGrid?.closest('.js-grid-wrapper')?.querySelector('viewed-counter'),
      currentFactsDesktop = document.querySelector('.js-active-facets-desktop'),
      currentPagination = document.getElementById('ScPagination'),
      productTitle = document.querySelector('.js-product-results-title'),
      incomingProductGrid = parser.getElementById('product-grid'),
      incomingFacetsDesktop = parser.querySelector('.js-active-facets-desktop'),
      incomingPagination = parser.getElementById('ScPagination'),
      incProductCounter = incomingProductGrid?.closest('.js-grid-wrapper')?.querySelector('viewed-counter'),
      incProductTitle = parser.querySelector('.js-product-results-title')

    if (!window.isSearchPage) {
      currentProductGrid.innerHTML = incomingProductGrid.innerHTML
      currentPagination.innerHTML = incomingPagination.innerHTML
      currentFactsDesktop.replaceWith(incomingFacetsDesktop)
    } else {
      currentProductGrid && (incomingProductGrid ? (currentProductGrid.innerHTML = incomingProductGrid.innerHTML) : (currentProductGrid.innerHTML = ''))
      currentPagination && (incomingPagination ? (currentPagination.innerHTML = incomingPagination.innerHTML) : (currentPagination.innerHTML = ''))
      currentFactsDesktop && (incomingFacetsDesktop ? currentFactsDesktop.replaceWith(incomingFacetsDesktop) : currentFactsDesktop.innerHTML = '')
    
      productCounter && (incProductCounter ? productCounter.replaceWith(incProductCounter) : productCounter.innerHTML = '')
      productTitle.replaceWith(incProductTitle)
      this.renderSearchForm(html)
    }
    
  }

  static renderProductCount(html) {
    const parser = new DOMParser()
    .parseFromString(html, 'text/html')

    const count = parser.getElementById('ProductCountDesktop')?.innerHTML;
    const countForTriiger = parser.getElementById('productCountButton')?.innerHTML;
    const container = document.getElementById('ProductCountDesktop');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const productCountButton = document.getElementById('productCountButton');
    container && (container.innerHTML = count ? count : '')
    container && (container.classList.remove('loading'))
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove('loading')
    }

    if (productCountButton) {
      productCountButton.innerHTML = countForTriiger
      productCountButton.classList.remove('loading')
    }

    if (window.isSearchPage) {
      const incProductsCount = parser.querySelector('.js-product-wrapper')?.querySelector('viewed-counter') && parser.querySelector('.js-product-wrapper')?.querySelector('viewed-counter')?.dataset?.total
      const resultsCountHolder = document.querySelector('result-count')
  
      resultsCountHolder.setAttribute('data-products', incProductsCount)
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    )
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    )
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ) &&
      (document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML)
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter')
      )
  }

  static renderSearchForm(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const searchForm = document.getElementById('SearchForm')
    const Title = searchForm.querySelector('h1')

    const incSearchForm = parsedHTML.getElementById('SearchForm')
    const incTitle = incSearchForm.querySelector('h1')

    Title.replaceWith(incTitle)
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ]

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML
    })

    // document
    //   .getElementById('FacetFiltersFormMobile')
    //   .closest('menu-drawer')
    //   .bindEvents()
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected')
    const sourceElement = source.querySelector('.facets__selected')

    const targetElementAccessibility = target.querySelector('.facets__summary')
    const sourceElementAccessibility = source.querySelector('.facets__summary')

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML =
        source.querySelector('.facets__summary').outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ]
  }

  createSearchParams(form, page, query) {
    const formData = new FormData(form)
    page && formData.set('page', page)
    query && formData.set('q', query)
    query && formData.set('type', 'product')
    return new URLSearchParams(formData).toString()
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  onSubmitHandler(event, page, query) {
    if (!event.target.classList.contains('active-facets__button-remove')) {
      event?.preventDefault()
    }
    const sortFilterForms = document.querySelectorAll('facet-filters-form form')
    if (
      event != undefined &&
      event?.srcElement.className == 'mobile-facets__checkbox'
    ) {
      const searchParams = this.createSearchParams(event.target.closest('form'), page, query)
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = []
    
      sortFilterForms.forEach((form) => {

        if ((form.id === 'FacetFiltersForm' || form.id === 'FacetSortForm') && window.innerWidth >= 992) {
          const noJsElements = document.querySelectorAll('.no-js-list')
          noJsElements.forEach((el) => el.remove())
          forms.push(this.createSearchParams(form, page, query))
        } else if (form.id === 'FacetFiltersForm' && window.innerWidth <= 991 ) {
          const noJsElements = document.querySelectorAll('.no-js-list')
          noJsElements.forEach((el) => el.remove())
          forms.push(this.createSearchParams(form, page, query))
        }
      })
      this.onSubmitForm(forms.join('&'), event)      
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1
          )
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector('a')
    facetLink.setAttribute('role', 'button')
    facetLink.addEventListener('click', this.closeFilter.bind(this))
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form')
    form.onActiveFilterClick(event)
  }
}

customElements.define('facet-remove', FacetRemove)

class BuilttFilterWrapper extends HTMLElement {
  static get observedAttributes() {
    return ['open']
  }
  constructor() {
    super()
    this.filterTriggers = this.querySelectorAll('.js-show-hide-trigger');
    this.filterWrapper = this.querySelector('.js-filter-wrapper');

    this.filterTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleAttribute('open')
        document.body.classList.toggle('is-overlay-active');
      })
    })
  }

  attributeChangedCallback() {
    if (this.open) {
      this.filterWrapper.classList.remove('-translate-x-full');
    } else {
      this.filterWrapper.classList.add('-translate-x-full');
    }
  }

  get open() {
    return this.hasAttribute("open");
  }
}

customElements.define('builtt-filters-wrapper', BuilttFilterWrapper)

class BuilttPriceRange extends HTMLElement {
  constructor() {
    super()
    import('nouislider/dist/nouislider.min.mjs').then((noUiSlider) => {
      const min = this.querySelector('#Filter-Price-GTE')
      const max = this.querySelector('#Filter-Price-LTE')
      const snapValues = [
        this.querySelector('.pr-lower'),
        this.querySelector('.pr-upper'),
      ]
      let minValue = Number(min.getAttribute('min'))
      let maxValue = Number(max.getAttribute('max'))

      min.value ? (minValue = min.value) : ''
      max.value ? (maxValue = max.value) : ''

      noUiSlider.create(this, {
        start: [minValue, maxValue],
        connect: true,
        step: 1,
        range: {
          min: [Number(min.getAttribute('min'))],
          max: [Number(max.getAttribute('max'))],
        },
        format: {
          from: Number,
          to: function (value) {
            return parseInt(value)
          },
        },
      })

      this.noUiSlider.on(
        'set',
        (values, handleNumber, unencoded, tap, positions, noUiSlider) => {
          let event = new Event('input', {
            bubbles: true,
            cancelable: true,
          })

          min.value = Math.round(unencoded[0])
          max.value = Math.round(unencoded[1])
          min.dispatchEvent(event)
        }
      )
      this.noUiSlider.on('update', (values, handle) => {
        snapValues[handle].innerHTML = values[handle]
      })
    })
  }
}

customElements.define('builtt-price-range', BuilttPriceRange)